export default __webpack_public_path__ + "images/pages/regimen_finder/skin_types/normal-to-oily-5f5163689e6116bbb2fe0d071cf49e0a.svg";